module.exports = __webpack_public_path__ + "static/media/Profile3.ac0fdca0.jpg";